import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class menuActionsComponent extends Component {
  @action
  async clickFunction() {
    if (this.args.menuClick) {
      await this.args.menuClick();
    }
    if (this.args.closeMenu) {
      await this.args.closeMenu();
    }
  }
}
